import { createAsyncStore } from "common/axios/asyncModel";
import { ScheduleRepository } from "repository/scheduleRepository";

// 일정 목록 조회
const scheduleList = createAsyncStore();
const onGetScheduleList = (meetingId: string) => {
    scheduleList.onGetAll(() => ScheduleRepository.onGetSchedules(meetingId));
}

// 일정 후보 생성
const createSchedule = createAsyncStore();
const onCreateSchedule = (params: any) => {
    createSchedule.onGetAll(() => ScheduleRepository.onPostCreateSchedule(params));
}

// 일정 투표
const voteSchedule = createAsyncStore();
const onVoteSchedule = (scheduleId: string, params: any) => {
    voteSchedule.onGetAll(() => ScheduleRepository.onPostVoteSchedule(scheduleId, params));
}

// 일정 확정
const confirmSchedule = createAsyncStore();
const onConfirmSchedule = (scheduleId: string) => {
    confirmSchedule.onGetAll(() => ScheduleRepository.onPostConfirmSchedule(scheduleId));
}

// AI 일정 추천
const aiRecommendSchedule = createAsyncStore();
const onGetAiRecommendSchedule = (meetingId: string) => {
    aiRecommendSchedule.onGetAll(() => ScheduleRepository.onGetAiRecommendSchedule(meetingId));
}

export const scheduleStore = {
    scheduleList,
    onGetScheduleList,

    createSchedule,
    onCreateSchedule,

    voteSchedule,
    onVoteSchedule,

    confirmSchedule,
    onConfirmSchedule,

    aiRecommendSchedule,
    onGetAiRecommendSchedule
}
